import { useState, } from 'react'
import { TitlePage } from '../../../TitlePage/TitlePage'
import { ButtonBasic, InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../../ModalComponent/ModalComponent';
import './ModalEditMenuItem.scss'

const ModalEditMenuItem = ({
    setIsModal,
    fetchChangeLevel,
    currentPoint = {},
    setCurrentPoint = () => { }
}) => {

    const [name, setName] = useState(currentPoint?.label || '')

    return (
        <ModalComponent
            title='Настройка:'
            onClose={(e) => {
                setCurrentPoint(null)
                setIsModal(false);
            }}
            style={{
                maxWidth: '400px',
                height: 'auto'
            }}
            child={
                <div className="modal-edit-menu-item">
                    <InputDinamycPlaceholder
                        changeValue={name}
                        onChange={(e) => setName(e)}
                        placeholder="Имя вкладки"
                        size='s'
                    />

                    <div className="modal-edit-menu-item__btn-group">
                        <ButtonBasic
                            blue
                            width={'calc(50% - 6px)'}
                            text='Сохранить'
                            onClick={(e) => {
                                fetchChangeLevel(name, currentPoint?.parent_id, currentPoint?.before, currentPoint?.id);
                                setIsModal(false)
                            }}
                        />

                        <ButtonBasic
                            grey
                            width={'calc(50% - 6px)'}
                            text='Отмена'
                            onClick={(e) => {
                                setCurrentPoint(null)
                                setIsModal(false)
                            }}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalEditMenuItem }